import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import {
  displayDateTimeField,
  displayField,
  isNotEmpty,
} from "../../../utils/helpers";

const OrderServiceRatingCell = ({
  rowData,
  positionFromRight = "20",
  withManagerFeedback = true,
  ...props
}: {
  rowData: any;
  positionFromRight?: any;
  withManagerFeedback?: boolean;
}) => {
  let orderStatus: String = rowData.order_status;
  const { t } = useTranslation();
  const { Cell } = Table;

  const speaker = (
    <Popover title={t("SERVICE") + " " + t("RATING") + ":"}>
      <p>
        <p>
          <b>{t("RATING")} :</b>
          {" " + displayField(rowData.service_rating)}

          <p>
            {" "}
            <b>{t("CUSTOMER") + " " + t("FEEDBACK")}:</b>{" "}
            {displayField(rowData.customer_feedback)}
          </p>

          {withManagerFeedback && (
            <>
              <p>
                {" "}
                <b>{t("MANAGER") + " " + t("FEEDBACK")}:</b>{" "}
                {displayField(rowData.manager_feedback)}
              </p>
              <p>
                {" "}
                <b>{t("MANAGER") + " " + t("NAME")}:</b>{" "}
                {displayField(rowData.manager_name)}
                {isNotEmpty(rowData.manager_phone) && (
                  <> {"(" + rowData.manager_phone + ")"}</>
                )}
              </p>
            </>
          )}
        </p>
        <p>
          <b>
            {t("SERVED")} {t("BY")}
          </b>
          : {displayField(rowData.served_by_name)}
          {isNotEmpty(rowData.served_by_phone) && (
            <> {"(" + rowData.served_by_phone + ")"}</>
          )}
          {isNotEmpty(rowData.served_at) && (
            <> {t("AT") + " " + displayDateTimeField(rowData.served_at)}</>
          )}
        </p>
      </p>
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a>{rowData.service_rating}</a>
      </Whisper>
    </Cell>
  );
};

export default OrderServiceRatingCell;
